// @flow
import React from 'react';
import Tooltip from '@homeaway/react-tooltip';
import {trigger as edapTrigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import exclusivityIcon from './icons/exclusivity-icon.svg';
import exclusivityIconVrbo from './icons/exclusivity-icon-vrbo.svg';
import {EXCLUSIVITY} from '../../constants/badges';
import classNames from 'classnames';
import './HitLabel.less';

type Props = {
    brand?: string,
    id?: string,
    label: string,
    parentNode?: ?HTMLBodyElement,
    toolTipText?: ?string
};

const triggerEdap = (label: string, id?: string) => {
    edapTrigger(GENERIC_EVENT, {
        eventaction: `Hit badge hover: ${id ? id : label}`,
        highfrequency: 'true'
    });
};

const labelText = ({label, id = '', brand}) => {
    const icon = brand === 'VRBO' ? exclusivityIconVrbo() : exclusivityIcon();
    return (
        <span
            role="presentation"
            className={classNames('HitInfo__labels_item label label-default', {
                [`label-${id}`]: !!id
            })}
            onMouseEnter={() => triggerEdap(label, id)}
        >
            {id === EXCLUSIVITY && <img src={icon} alt={label} />}
            {label}
        </span>
    );
};

const HitLabel = ({label, toolTipText, parentNode, id, brand}: Props) => {
    if (toolTipText) {
        return (
            <Tooltip
                tooltipType="popover"
                placement="top"
                content={toolTipText}
                parentNode={parentNode}
                interactiveContainer
                portalClassName="HitInfoTooltip__wrapper"
            >
                {labelText({label, id, brand})}
            </Tooltip>
        );
    }
    return labelText({label, id, brand});
};

export default HitLabel;
